
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"19","height":"19","rx":"3.5","fill":"#EFF1F7","stroke":"#D3D7E1"}}),_c('path',{attrs:{"d":"M11.208 13.915v.31c0 .245-.184.45-.424.484l-.078.28a.355.355 0 01-.344.26h-.77a.355.355 0 01-.345-.26l-.075-.28a.495.495 0 01-.426-.487v-.309a.3.3 0 01.304-.298h1.854a.303.303 0 01.304.3zm1.427-4.163c0 .703-.284 1.34-.746 1.808a2.37 2.37 0 00-.652 1.296.437.437 0 01-.435.363h-1.65a.433.433 0 01-.433-.36 2.396 2.396 0 00-.657-1.302A2.566 2.566 0 017.32 9.78C7.305 8.332 8.482 7.16 9.96 7.15c1.476-.011 2.675 1.159 2.675 2.603zm-2.357-1.577a.297.297 0 00-.3-.293c-1.057 0-1.918.841-1.918 1.879 0 .16.133.294.3.294.164 0 .3-.131.3-.294 0-.714.592-1.292 1.318-1.292.166 0 .3-.13.3-.294z","fill":"#525F7F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.959 5.9a.592.592 0 01-.592-.591V4.126a.592.592 0 011.183 0v1.183a.592.592 0 01-.591.591zM6.606 7.427a.592.592 0 01-.837 0l-.837-.836a.592.592 0 01.837-.837l.837.837a.592.592 0 010 .836zM2.703 10.19c0-.327.265-.592.592-.592h1.183a.592.592 0 010 1.183H3.295a.592.592 0 01-.592-.592zM14.848 10.19c0-.327.264-.592.591-.592h1.183a.592.592 0 110 1.183H15.44a.592.592 0 01-.591-.592zM13.398 7.427a.592.592 0 00.837 0l.836-.836a.592.592 0 10-.836-.837l-.837.837a.592.592 0 000 .836z","fill":"#525F7F"}})])
          )
        }
      }
    